import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";

@JsonObject("DocumentUpdateInput")
export class DocumentUpdateInput {
    @JsonProperty("slug", String, true)
    public slug?: string = JsonPropertyEmpty;

    @JsonProperty("archived", Boolean, true)
    public archived?: boolean = JsonPropertyEmpty;

    public constructor(args?: Partial<DocumentUpdateInput>) {
        Object.assign(this, args);
    }
}
